import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { IonicVue } from "@ionic/vue";

/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import "./theme/style.scss";
import { createPinia } from "pinia";
import axios from "axios";
import { baseURL } from "@/services/api";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { useAuthStore } from "@/stores/auth";
import { Network } from "@capacitor/network";
import { useNetworkStore } from "@/stores/network";
import { useInspectionsStore } from "@/stores/inspections";
import * as Sentry from "@sentry/vue";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const app = createApp(App)
    .use(IonicVue, {
        innerHTMLTemplatesEnabled: true,
    })
    .use(pinia)
    .use(router);

if (import.meta.env.MODE != "development") {
    Sentry.init({
        app,
        dsn: "https://cd025f0b095112778f944265d10f996c@o4509114312753153.ingest.de.sentry.io/4509424590127184",
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
    });
}

axios.defaults.baseURL = baseURL;
axios.defaults.validateStatus = () => true;
axios.interceptors.request.use((config) => {
    const authStore = useAuthStore();
    config.headers["Content-Type"] = "application/json";
    if (authStore.isAuthenticated) {
        config.headers["Authorization"] = `Token ${authStore.getToken}`;
    }
    return config;
});

const checkConnection = async () => {
    const networkStore = useNetworkStore();
    const authStore = useAuthStore();
    const connectionStatus = await Network.getStatus();
    networkStore.setNetworkState(connectionStatus.connected).then(() => {
        if (authStore.isAuthenticated && connectionStatus.connected) {
            const inspectionsStore = useInspectionsStore();
            inspectionsStore.syncData();
        }
    });
};
//document.addEventListener("pause", () => checkConnection, false);
document.addEventListener("resume", checkConnection, false);

Network.addListener("networkStatusChange", (status) => {
    const networkStore = useNetworkStore();
    networkStore.setNetworkState(status.connected);
});

Promise.all([router.isReady(), Network.getStatus()]).then(async (values) => {
    const networkStore = useNetworkStore();
    await networkStore.setNetworkState(values[1].connected).then(() => {
        if (values[1].connected) {
            const inspectionsStore = useInspectionsStore();
            inspectionsStore.syncData();
        }
    });
    app.mount("#app");
});
